import { MediaUploadInput } from "../../components/MediaUploadInput";
import { RegisterCard } from "../../components/RegisterCard";
import { CircleLoader } from "../../components/CircleLoader";
import {
  FileText,
  Megaphone,
  Calendar,
  Sparkles,
  PlusCircle,
} from "lucide-react";

export const CAnotes = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const noteTypes = [
    { id: "notice", label: "Notice", icon: <Megaphone size={16} /> },
    { id: "Event", label: "Event", icon: <Calendar size={16} /> },
    { id: "others", label: "Others", icon: <Sparkles size={16} /> },
  ];

  return (
    <div className="w-full max-w-4xl mx-auto p-4 animate-in fade-in duration-500">
      <RegisterCard
        title="Notes & Updates"
        details="General announcements for parents."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-6 sm:p-10 space-y-8 order-2 lg:order-1">
          {/* Note Type Selection */}
          <div className="space-y-3">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Category
            </label>
            <div className="grid grid-cols-3 gap-3">
              {noteTypes.map((type) => (
                <button
                  key={type.id}
                  type="button"
                  onClick={() => onFormChange("type", type.id)}
                  className={`py-3 rounded-2xl border-2 font-bold text-sm flex flex-col items-center gap-2 transition-all
                    ${formData["type"] === type.id ? "bg-blue-600 border-blue-600 text-white shadow-lg shadow-blue-200" : "bg-slate-50 border-transparent text-slate-400 hover:bg-slate-100"}`}
                >
                  {type.icon}
                  {type.label}
                </button>
              ))}
            </div>
          </div>

          {/* Description */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <FileText size={14} className="text-blue-500" /> Description
            </label>
            <textarea
              name="description"
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              placeholder="Write the details of the note or event here..."
              className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-[1.5rem] min-h-[140px] focus:bg-white focus:border-blue-500 transition-all outline-none resize-none shadow-inner"
            />
          </div>

          {/* Media Upload */}
          <div className="space-y-3">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Attachments
            </label>
            <div className="p-4 bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl hover:border-blue-400 transition-colors">
              <MediaUploadInput
                singleOption={false}
                onChangeFn={(e: any, type: any) =>
                  onFormChange(
                    type === "video"
                      ? "video"
                      : type === "image"
                        ? "image"
                        : "doc",
                    e?.target.files
                      ? type === "video"
                        ? e.target.files[0]
                        : e.target.files
                      : "",
                  )
                }
                className="w-full flex flex-col items-center"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 hover:bg-black text-white rounded-2xl font-black uppercase tracking-widest transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <PlusCircle size={20} /> Publish Note
              </>
            )}
          </button>
        </div>

        {/* Branding Sidebar */}
        <div className="lg:w-64 bg-slate-50 flex items-center justify-center p-8 order-1 lg:order-2 border-b lg:border-b-0 lg:border-l border-slate-100">
          <img
            src="/img/notes.svg"
            className="w-32 h-32 lg:w-48 lg:h-48 drop-shadow-2xl animate-float"
            alt="notes"
          />
        </div>
      </form>
    </div>
  );
};
